import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import api from "../lib/api";
import { isTrialExpired, TRIAL_PRICING_PATH } from "@/lib/connectTrial";

const ProtectedRoute = ({ children, isAuthenticated, requiredPermission, requiredSection, user }) => {
  const location = useLocation();
  const gateConnect = requiredPermission === "can_access_walmart";
  const [connectStatus, setConnectStatus] = useState(undefined);

  useEffect(() => {
    if (!isAuthenticated || !gateConnect) return undefined;
    let cancelled = false;
    const load = () => {
      api.get("/connect/status")
        .then((r) => { if (!cancelled) setConnectStatus(r.data || null); })
        .catch(() => { if (!cancelled) setConnectStatus(null); });
    };
    load();
    const onChange = () => load();
    window.addEventListener("connect-status-changed", onChange);
    return () => {
      cancelled = true;
      window.removeEventListener("connect-status-changed", onChange);
    };
  }, [isAuthenticated, gateConnect]);

  if (!isAuthenticated) {
    const returnTo = location.pathname + location.search;
    return <Navigate to={`/login?returnTo=${encodeURIComponent(returnTo)}`} replace />;
  }

  if (requiredPermission) {
    if (!user) {
      return null;
    }
    if (!user[requiredPermission]) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  if (gateConnect) {
    if (connectStatus === undefined) {
      return null;
    }
    if (isTrialExpired(connectStatus)) {
      return <Navigate to={TRIAL_PRICING_PATH} replace />;
    }
  }

  // Section access for restricted members is shown in-page (grayed nav +
  // store-named overlay). Do not bounce them to the dashboard.

  return children;
};

export default ProtectedRoute;
